/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!******************************************************!*\
  !*** ./src/scripts/components/search-suggestions.js ***!
  \******************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var searchSuggestions = function searchSuggestions() {
  return {
    url: new URL(window.location.href),
    searchFormIsOpen: false,
    searchInput: document.querySelector("#search_input"),
    searchResults: [],
    resultsCount: 0,
    currentSearchQuery: "",
    searchInputValue: "",
    searchForm: null,
    init: function init() {
      var _this = this;
      this.searchForm = document.querySelector(".js-search-form__container form");
      this.searchInput.addEventListener("input", this.debounce(function (event) {
        _this.onChange(event);
      }, 300).bind(this));

      //this.searchInputValue = this.url.searchParams.get('q')

      window.addEventListener("open-search", function () {
        _this.searchFormIsOpen = true;
        setTimeout(function () {
          return _this.searchInput.focus();
        }, 50);
        document.body.classList.add("overflow-hidden");
      });
      window.addEventListener("close-search", function () {
        _this.searchFormIsOpen = false;
        document.body.classList.remove("overflow-hidden");
        _this.resetSearchForm();
      });
      if (this.searchInputValue) {
        this.getSearchResults(this.searchInputValue);
      }
    },
    resetSearchForm: function resetSearchForm() {
      if (this.searchForm) {
        this.searchForm.reset();
        this.searchInputValue = "";
        this.searchResults = [];
        this.resultsCount = 0;
      }
    },
    onChange: function onChange() {
      var searchTerm = this.searchInput.value;
      if (!searchTerm.length) {
        this.searchResults = [];
        this.resultsCount = 0;
        this.currentSearchQuery = "";
        this.url.searchParams["delete"]("q");
        history.replaceState({}, null, window.location.origin + window.location.pathname);
        return;
      }
      this.searchInputValue = searchTerm;
      this.currentSearchQuery = "/search?q=".concat(searchTerm, "&type=product");
      this.url.searchParams.set("q", searchTerm);
      history.replaceState(null, null, "?q=" + searchTerm + "&type=product");
      this.getSearchResults(searchTerm);
    },
    getSearchResults: function getSearchResults(searchTerm) {
      var _this2 = this;
      fetch("/search/suggest.json?q=".concat(searchTerm, "&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,variants.title,product_type&resources[limit]=6")).then(function (response) {
        return response.json();
      }).then(function (suggestions) {
        var productSuggestions = suggestions.resources.results.products;
        _this2.searchResults = productSuggestions;
        _this2.resultsCount = _this2.searchResults.length;
        /*document.documentElement.classList.add('search-lock');*/

        if (productSuggestions.length > 0) {
          var firstProductSuggestion = productSuggestions[0];
        }
      });
    },
    debounce: function debounce(fn, wait) {
      var _this3 = this;
      var t;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        clearTimeout(t);
        t = setTimeout(function () {
          return fn.apply(_this3, args);
        }, wait);
      };
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (searchSuggestions);
document.addEventListener("alpine:init", function () {
  Alpine.data("searchSuggestions", searchSuggestions);
});
/******/ })()
;